import { computed } from 'vue'
import { IRREGULARITIES_TRANSLATION_NAMESPACE as NS } from '@/modules/road-maintenance-module/winter-service-v2/irregularities/config/constants'

const COMMENT_ROWS = 8

/**
 * The fields of a single irregularity report. All of it is what the driver's device
 * sent, and the backend exposes the report read-only - there is no update endpoint -
 * so every field is shown and none is editable.
 *
 * The values are the flat ones `irregularityData` derives from the nested record,
 * which is also why the timestamp is a plain field: it arrives already formatted.
 */
export function useIrregularityFields (options) {
  const { translate } = options || {}

  const readOnlyField = (key, label, extra = {}) => ({
    key,
    label,
    editable: false,
    creatable: false,
    visible: true,
    ...extra
  })

  const fields = computed(() => ([
    readOnlyField('id', translate(`${NS}.id`)),
    readOnlyField('vehicle', translate(`${NS}.vehicle`)),
    readOnlyField('driver', translate(`${NS}.driver`)),
    readOnlyField('reported_at', translate(`${NS}.reported_at`)),
    readOnlyField('irregularity_type', translate(`${NS}.irregularity_type`)),
    readOnlyField('task', translate(`${NS}.task`)),
    readOnlyField('address', translate(`${NS}.address`)),
    readOnlyField('comment', translate(`${NS}.comment`), {
      type: 'textarea',
      rows: COMMENT_ROWS
    })
  ]))

  return {
    fields
  }
}
